/**
 * @packageDocumentation
 * @module      P_Arm_SensorStatus.ts
 * @description Contains Emc related data for Arm Sersor Status
 * @copyright   Copyright © 2025 Siemens Healthineers. All rights reserved.
 */
import { toFixedDecimal } from "../utils";
export default class P_Arm_SensorStatus {
    constructor() {
        this.LockedFromArm = '0';
        this.ArmPresentRemoved = '0';
        this.ProximalAnchor = '0';
        this.DistalAnchor = '0';
    }
    static sensorStatus(isLocked) {
        const buttonPressed = toFixedDecimal(isLocked); //can be any non-zero number
        const buttonReleased = toFixedDecimal(0);
        return toFixedDecimal(isLocked) === buttonReleased ?
            buttonReleased :
            buttonPressed;
    }
    static fromJSON(json) {
        if (json) {
            let p_Arm_SensorStatus = new P_Arm_SensorStatus();
            if (json.LockedFromArm) {
                p_Arm_SensorStatus.LockedFromArm = P_Arm_SensorStatus.sensorStatus(json.LockedFromArm);
            }
            if (json.ArmPresentRemoved) {
                p_Arm_SensorStatus.ArmPresentRemoved = P_Arm_SensorStatus.sensorStatus(json.ArmPresentRemoved);
            }
            if (json.ProximalAnchor) {
                p_Arm_SensorStatus.ProximalAnchor = P_Arm_SensorStatus.sensorStatus(json.ProximalAnchor);
            }
            if (json.DistalAnchor) {
                p_Arm_SensorStatus.DistalAnchor = P_Arm_SensorStatus.sensorStatus(json.DistalAnchor);
            }
            return p_Arm_SensorStatus;
        }
        return null;
    }
}
//# sourceMappingURL=P_Arm_SensorStatus.js.map